module.exports = __webpack_public_path__ + "img/chr_ts_18_penlight.b56790ff.png";